import { ReactComponent as EditIcon } from '../../../assets/icons/edit-dark.svg';
import { ReactComponent as PeopleIcon } from '../../../assets/icons/remove_red_eye.svg';
import { isArray } from '../../../utility/helpers';

export const DATE_FORMAT = 'dd MMM yyyy';

export const getMenuItems = (translations, canEdit, onEdit, onViewPipeline) => [
  {
    type: 'edit',
    label: translations.menuItemLabels.edit,
    shouldItemRender: () => canEdit,
    action: onEdit,
    icon: EditIcon,
  },
  {
    type: 'viewPipeline',
    label: translations.menuItemLabels.viewPipeline,
    shouldItemRender: () => true,
    action: onViewPipeline,
    icon: PeopleIcon,
  },
];

export const sumCandidates = steps => {
  if (!isArray(steps)) {
    return 0;
  }

  return steps.reduce((acc, step) => {
    return acc + (Number(step.number_of_candidates) || 0);
  }, 0);
};

export const WORKSPACE_MAP = {
  ON_SITE: {
    id: 'on-site',
    label: 'On-site',
  },
  HYBRID: {
    id: 'hybrid',
    label: 'Hybrid',
  },
  REMOTE: {
    id: 'remote',
    label: 'Remote',
  },
};
